<template>
  <div class="stock-kline-view">
    <StockKLine5Day :stock-code.sync="stockCode" />
  </div>
</template>

<script>
import StockKLine5Day from '@/components/kline/StockKLine5Day.vue'

export default {
  name: 'StockKLine5DayView',
  components: {
    StockKLine5Day
  },
  data() {
    return {
      stockCode: 'sz.002602'
    }
  },
  created() {
    if (this.$route.query.code) {
      this.stockCode = this.$route.query.code
    }
  }
}
</script>

<style scoped>
.stock-kline-view {
  padding: 20px;
  flex: 1;
}
</style>
